import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useContext } from "react";
import { TextMode, } from "@plansoft-configuration-renderer/framework";
import { CommonComponentsContext } from "../Common/CommonComponents";
export function MarkdownOrText(props) {
    const { Markdown } = useContext(CommonComponentsContext);
    const { text, textMode } = props;
    if (!text) {
        return _jsx(Fragment, {});
    }
    if (textMode === TextMode.Markdown) {
        return _jsx(Markdown, { src: text });
    }
    return _jsx(Fragment, { children: text });
}
//# sourceMappingURL=MarkdownOrText.js.map